import React from 'react';

import Image from './Image';

export default function ImagesList({
  images,
  setTouched,
  setFieldValue,
  name,
}) {
  return (
    <ul className="flex gap-4 flex-wrap w-full">
      {images.map((image) => {
        return (
          <Image
            image={image}
            key={image.name || image.url}
            setTouched={setTouched}
            deleteImage={() => {
              setFieldValue(
                name,
                images.filter((img) => img.name !== image.name)
              );
            }}
          />
        );
      })}
    </ul>
  );
}
